/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { GetService, PostService } from "../../../Services/ConstantService";
import { API_URL } from "../../../Services/ApiService";
import { ImageURL } from "../../../Environment/Environment";
import { BounceLoader } from "react-spinners";
import {
  OrderPlacedAlert,
  showGuestUserExistAlert,
  toastEmmit,
} from "../../../Helper/Toastr";
import { useCart } from "../../CartContext";
import PayPalButtonComponent from "../Paypal/PayPalButtonComponent";
import PhoneInput from "react-phone-input-2";
import BraintreeCheckout from "../Braintree/BraintreeCheckout";

export default function CheckOut() {
  const navigate = useNavigate();

  const [CartList, setCartList] = useState([]);
  const [SuggestesList, setSuggestesList] = useState([]);
  const [suggestedItem, setsuggestedItem] = useState(false);
  const [CardSummary, setCardSummary] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [btnLoader, setbtnLoader] = useState(false);

  const [CountryList, setCountryList] = useState([]);
  const [StateList, setStateList] = useState([]);
  const [ShippingStateList, setShippingStateList] = useState([]);
  const [shipToDifferentAddress, setshipToDifferentAddress] = useState(false);
  const [paypal, setpaypal] = useState(false);

  const [PromoCodeDetails, setPromoCodeDetails] = useState(0);
  const { updateCart } = useCart();

  const clientId =
    "AYydSBkKnXL2kBJwFhIhQiS9Su8XIs8V_v7iU7dAOldj9KbCGSlheB1G_hLttnF2szMx7ML1-Cmio3-M";
  const amount = "10.00";

  useEffect(() => {
    GetCountryList();
    GetcartListDetail();
    GetShippingDetails();
    SuggestedProducts();
  }, []);

  const GetcartListDetail = () => {
    setLoading(true);
    GetService(API_URL.GET_CART_LIST).then((res) => {
      console.log(res);
      if (res?.data?.status) {
        setCartList(res?.data?.data);
        // setCardSummary(res?.data?.summary);
        setCardSummary(() => {
          const newCardSummary = { ...res?.data?.summary };
          const newTotal =
            parseFloat(res?.data?.summary.subtotal || 0.0) +
            parseFloat(res?.data?.summary.shippingprice || 0.0);
          newCardSummary.total = newTotal.toFixed(2) || 0.0;
          newCardSummary.discount = 0;
          newCardSummary.suggested_item_price = 0;
          return newCardSummary;
        });
      }
      setLoading(false);
    });
  };

  const SuggestedProducts = () => {
    setLoading(true);
    GetService(API_URL.GET_SUGGESTED_PRODUCTS).then((res) => {
      console.log(res);
      if (res?.data?.status) {
        setSuggestesList(res?.data?.data);
      }
      setLoading(false);
    });
  };

  const GetShippingDetails = () => {
    setLoading(true);
    GetService(API_URL.GET_SHIPPING_DETAILS).then((res) => {
      console.log(res);
      if (res?.data?.status) {
        const data = res?.data?.data[0];
        GetShippingStateList(data?.country);
        GetStateList(data?.country);
        formik.setValues({
          ...formik.values,
          firstName: data?.first_name,
          lastName: data?.last_name,
          email: data?.email,
          phoneNumber: data?.contact_no,
          country: data?.country,
          state: data?.state,
          city: data?.city,
          address: data?.address,
          zip: data?.zip_code,
          shipping_country: data?.country,
          shipping_state: data?.state,
          shipping_city: data?.city,
          shipping_zip: data?.zip_code,
          shipping_address: data?.address,
        });
      }
      setLoading(false);
    });
  };

  const GetCountryList = () => {
    setLoading(true);
    GetService(API_URL.GET_COUNTRY_LIST).then((res) => {
      console.log(res);
      if (res?.data?.status) {
        setCountryList(res?.data?.data);
        setLoading(false);
      }
    });
  };

  const GetStateList = (cid) => {
    setLoading(true);
    GetService(`${API_URL.GET_STATE_LIST}?country_id=${cid}`).then((res) => {
      console.log(res);
      setLoading(false);
      if (res?.data?.status) {
        setStateList(res?.data?.data);
      }
    });
  };

  const GetShippingStateList = (cid) => {
    setLoading(true);
    GetService(`${API_URL.GET_STATE_LIST}?country_id=${cid}`).then((res) => {
      console.log(res);
      setLoading(false);
      if (res?.data?.status) {
        setShippingStateList(res?.data?.data);
      }
    });
  };

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      shipToDifferentAddress: false,
      country: "",
      state: "",
      city: "",
      address: "",
      zip: "",
      shipping_country: "",
      shipping_state: "",
      shipping_city: "",
      shipping_address: "",
      shipping_zip: "",
      promoCode: "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("Required"),
      lastName: Yup.string().required("Required"),
      email: Yup.string().email("Invalid email address").required("Required"),
      phoneNumber: Yup.string()
        .required("Required")
        .min(10, "Proper number is required"),
      country: Yup.string().required("Required"),
      state: Yup.string().required("Required"),
      city: Yup.string().required("Required"),
      address: Yup.string().required("Required"),
      zip: Yup.string().required("Required"),

      shipping_country: shipToDifferentAddress
        ? Yup.string().required("Required")
        : Yup.string(),
      shipping_state: shipToDifferentAddress
        ? Yup.string().required("Required")
        : Yup.string(),
      shipping_city: shipToDifferentAddress
        ? Yup.string().required("Required")
        : Yup.string(),
      shipping_address: shipToDifferentAddress
        ? Yup.string().required("Required")
        : Yup.string(),
      shipping_zip: shipToDifferentAddress
        ? Yup.string().required("Required")
        : Yup.string(),
    }),
    onSubmit: (values) => {
      // console.log(values);
      if (localStorage.getItem("userType") === "guestLogin") {
        CheckContactDetails();
      } else {
        if (CardSummary?.total >= 0) {
          document.getElementById("paymentModal").click();
          setpaypal(true);
        } else {
          toastEmmit("info", "Total amount must be greater then equal to 0");
        }
      }
    },
  });

  const CheckContactDetails = () => {
    setbtnLoader(true);
    const obj = {
      email: formik.values.email,
      phoneNumber: formik.values.phoneNumber,
    };
    PostService(API_URL.CHECK_GUEST_CONTACT_DETAILS, obj).then(
      (res) => {
        console.log(res);
        setbtnLoader(false);
        if (res?.data?.status) {
          if (res?.data?.data) {
            showGuestUserExistAlert(SettingLoginModalOpen);
          } else {
            if (CardSummary?.total >= 0) {
              document.getElementById("paymentModal").click();
              setpaypal(true);
            } else {
              toastEmmit(
                "info",
                "Total amount must be greater then equal to 0"
              );
            }
          }
        } else toastEmmit("error", res?.data?.message);
      },
      (err) => {
        setbtnLoader(false);
        // console.log(err?.response?.data?.message);
        toastEmmit("error", err?.response?.data?.message);
      }
    );
  };

  function SettingLoginModalOpen() {
    document.getElementById("openloginModalforGuest").click();
  }

  const ProceedToSelectMethod = (paymentdetails) => {
    setLoading(true);
    const commonPayload = {
      firstName: formik.values.firstName,
      lastName: formik.values.lastName,
      email: formik.values.email,
      phoneNumber: formik.values.phoneNumber,
      shipToDifferentAddress: formik.values.shipToDifferentAddress,
      country: formik.values.country,
      state: formik.values.state,
      city: formik.values.city,
      address: formik.values.address,
      zip: formik.values.zip,
      promoCode:
        formik.values.promoCode && PromoCodeDetails?.type && PromoApplySubmit
          ? formik?.values?.promoCode
          : "",
      orderSummery: CardSummary,
      orderItems: CartList,
      // orderItems: [...Object.values(CartList), ...Object.values(SuggestesList)],
      suggested_Items: suggestedItem,
      suggested_Items_Id: suggestedItem ? SuggestesList[0]?.id : "",
      // paymentDetails: paymentdetails,
      paymentDetails: { paymentMethodNonce: paymentdetails }
    };
    if (formik.values.shipToDifferentAddress) {
      const shippingPayload = {
        shipping_country: formik.values.shipping_country,
        shipping_state: formik.values.shipping_state,
        shipping_city: formik.values.shipping_city,
        shipping_address: formik.values.shipping_address,
        shipping_zip: formik.values.shipping_zip,
      };

      const payload = { ...commonPayload, ...shippingPayload };
      sendApiRequest(payload);
      // updateshippingAddress(shippingPayload);
    } else {
      sendApiRequest(commonPayload);
    }
  };

  const sendApiRequest = (payload) => {
    console.log("Sending API request with payload:", payload);
    PostService(API_URL.Checkout, payload).then(
      (res) => {
        setLoading(false);
        document.getElementById("close").click();
        console.log(res);
        if (res?.data?.status) {
          console.log(res?.data?.message);
          updateCart(res?.data?.summary?.cartCount);
          localStorage.setItem("count", res?.data?.summary?.cartCount);
          if (localStorage.getItem("userType") === "guestLogin") {
            localStorage.setItem(
              "user",
              res?.data?.data?.bfname + " " + res?.data?.data?.blname
            );
            localStorage.setItem("userType", "");
          }
          OrderPlacedAlert(
            navigatetoOrderDetail,
            navigatetoHome,
            res?.data?.summary?.id,
            navigate("/profile-dashboard/my-orders")
          );
        } else toastEmmit("error", res?.data?.message);
      },
      (err) => {
        setLoading(false);
        console.log(err?.response?.data?.message);
        toastEmmit("error", err?.response?.data?.message);
      }
    );
  };

  function navigatetoOrderDetail(id) {
    navigate(
      id
        ? `/profile-dashboard/my-orders/details/${id}`
        : "/profile-dashboard/my-orders"
    );
  }
  function navigatetoHome() {
    navigate("/home");
  }

  const updateshippingAddress = (payload) => {
    const Data = {
      country: payload.shipping_country,
      state: payload.shipping_state,
      city: payload.shipping_city,
      address: payload.shipping_address,
      zip_code: payload.shipping_zip,
    };
    PostService(API_URL.UPDATE_SHIPPING_DETAILS, Data).then(
      (res) => {
        setLoading(false);
        console.log(res);
        if (res?.data?.status) {
          console.log(res?.data?.message);
        } else toastEmmit("error", res?.data?.message);
      },
      (err) => {
        setLoading(false);
        console.log(err?.response?.data?.message);
        toastEmmit("error", err?.response?.data?.message);
      }
    );
  };

  // function ProceedToPay(params) {
  //   document.getElementById("close").click();
  //   navigate('/paymentProcess');
  // }

  const onSuccess = (details) => {
    console.log("Payment detail:", details);
    // if (details?.status === "COMPLETED") {
    if (details) {
      ProceedToSelectMethod(details);
    }
  };

  // const onError = (err) => {
  //   console.error("Payment error:", err);
  //   toastEmmit("Error", "Something went wrong");
  // };

  const [PromoApplySubmit, setPromoApplySubmit] = useState(false);

  const ApplyPromoCode = () => {
    if (!formik.values.promoCode) {
      setPromoApplySubmit(true);
      return;
    }
    setLoading(true);
    PostService(API_URL.APPLY_PROMO_CODE, {
      couponCode: formik.values.promoCode,
    }).then(
      (res) => {
        console.log(res);
        setLoading(false);
        if (res?.data?.status) {
          setPromoApplySubmit(true);
          setPromoCodeDetails(res?.data?.data);
          if (res?.data?.data?.type === "fixed") {
            const discountAmount = parseFloat(res?.data?.data?.discount);
            setCardSummary((prevCardSummary) => ({
              ...prevCardSummary,
              discount: discountAmount.toFixed(2),
              total: (
                parseFloat(prevCardSummary.subtotal) +
                parseFloat(prevCardSummary.shippingprice) +
                parseFloat(prevCardSummary.suggested_item_price) -
                discountAmount
              ).toFixed(2),
            }));
          } else if (res?.data?.data?.type === "percent") {
            const discountPercent = parseFloat(res?.data?.data?.discount);
            const discountAmount =
              (parseFloat(CardSummary.subtotal) * discountPercent) / 100;
            setCardSummary((prevCardSummary) => ({
              ...prevCardSummary,
              discount: discountAmount.toFixed(2),
              total: (
                parseFloat(prevCardSummary.subtotal) +
                parseFloat(prevCardSummary.shippingprice) +
                parseFloat(prevCardSummary.suggested_item_price) -
                discountAmount
              ).toFixed(2),
            }));
          }
        } else {
          toastEmmit("error", res?.data?.message);

          setPromoCodeDetails("");
          const discountAmount = 0;
          setCardSummary((prevCardSummary) => ({
            ...prevCardSummary,
            discount: discountAmount.toFixed(2),
            total: (
              parseFloat(prevCardSummary.subtotal) +
              parseFloat(prevCardSummary.shippingprice) +
              parseFloat(prevCardSummary.suggested_item_price) -
              discountAmount
            ).toFixed(2),
          }));
        }
      },
      (err) => {
        setLoading(false);
        setPromoApplySubmit(false);
        console.log(err?.response?.data?.message);
        toastEmmit("error", err?.response?.data?.message);
      }
    );
  };

  const removePromoCode = () => {
    setLoading(true);
    PostService(API_URL.APPLY_PROMO_CODE, {
      couponCode: "",
    }).then(
      (res) => {
        setLoading(false);
        setPromoApplySubmit(false);
        if (res?.data?.status) {
          setPromoCodeDetails("");
          formik.setFieldValue("promoCode", "");
          const discountAmount = 0;
          setCardSummary((prevCardSummary) => ({
            ...prevCardSummary,
            discount: discountAmount.toFixed(2),
            total: (
              parseFloat(prevCardSummary.subtotal) +
              parseFloat(prevCardSummary.shippingprice) +
              parseFloat(prevCardSummary.suggested_item_price) -
              discountAmount
            ).toFixed(2),
          }));
        } else {
          toastEmmit("error", res?.data?.message);
        }
      },
      (err) => {
        setLoading(false);
        setPromoApplySubmit(false);
        console.log(err?.response?.data?.message);
        toastEmmit("error", err?.response?.data?.message);
      }
    );
  };

  const suggestedChanges = (e, data) => {
    setsuggestedItem(e.target.checked);

    setCardSummary((prevCardSummary) => ({
      ...prevCardSummary,
      total: e.target.checked
        ? (
            parseFloat(prevCardSummary?.total) + parseFloat(data?.price)
          ).toFixed(2)
        : (
            parseFloat(prevCardSummary?.total) - parseFloat(data?.price)
          ).toFixed(2),
      suggested_item_price: e.target.checked ? data?.price : 0,
    }));
  };

  return (
    <div className="enhancements prices prices-one Print">
      <main>
        {/* checkout section */}
        <section
          className="tp-checkout-area pb-35 pt-3 Checkout-page"
          style={{ background: "#fffff" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="tp-checkout-bill-area">
                  <h3 className="tp-checkout-bill-title mb-0">Checkout</h3>
                  {/* <div className="d-flex main-text mb-20">
                      <h3 className="short-number">1</h3>
                      <h3 className="short-ntitle">Checkout</h3>
                    </div> */}

                  <hr className="mt-1" />
                  <div className="tp-checkout-bill-form">
                    <form>
                      <div className="tp-checkout-bill-inner">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="tp-checkout-input">
                              <label>
                                First Name<sup className="error">*</sup>
                              </label>
                              <input
                                type="text"
                                placeholder="First Name"
                                name="firstName"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.firstName}
                              />
                              {formik.touched.firstName &&
                              formik.errors.firstName ? (
                                <div className="error">
                                  {formik.errors.firstName}
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="tp-checkout-input">
                              <label>
                                Last Name<sup className="error">*</sup>
                              </label>
                              <input
                                type="text"
                                placeholder="Last Name"
                                name="lastName"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.lastName}
                              />
                              {formik.touched.lastName &&
                              formik.errors.lastName ? (
                                <div className="error">
                                  {formik.errors.lastName}
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="tp-checkout-input">
                              <label>
                                Email<sup className="error">*</sup>
                              </label>
                              <input
                                type="text"
                                placeholder="Email"
                                name="email"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.email}
                              />
                              {formik.touched.email && formik.errors.email ? (
                                <div className="error">
                                  {formik.errors.email}
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="tp-checkout-input height-45">
                              <label>
                                Phone Number<sup className="error">*</sup>
                              </label>
                              <PhoneInput
                                country={"us"}
                                value={formik.values.phoneNumber}
                                onChange={(e) => {
                                  const formattedNumber = `+${e.replace(
                                    /\D/g,
                                    ""
                                  )}`;
                                  formik.setFieldValue(
                                    "phoneNumber",
                                    formattedNumber
                                  );
                                  // console.log(formattedNumber);
                                }}
                              />
                              {/* <input
                                type="text"
                                placeholder="Phone No"
                                name="phoneNumber"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.phoneNumber}
                              /> */}
                              {formik.touched.phoneNumber &&
                              formik.errors.phoneNumber ? (
                                <div className="error">
                                  {formik.errors.phoneNumber}
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="tp-checkout-option-wrapper">
                              <h5 className="fw-semibold">Billing Address</h5>
                              <div className="tp-checkout-option">
                                <input
                                  id="create_free_account"
                                  type="checkbox"
                                  name="shipToDifferentAddress"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    setshipToDifferentAddress(e.target.checked);
                                  }}
                                  onBlur={formik.handleBlur}
                                  checked={formik.values.shipToDifferentAddress}
                                />
                                <label htmlFor="create_free_account">
                                  Ship to a different address?
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="tp-checkout-input">
                              <label>Country</label>
                              <select
                                id="country"
                                name="country"
                                className="checkoutSelect nice-select selectsection form-select"
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  GetStateList(e.target.value);
                                  formik.setFieldValue("state", "");
                                }}
                                onBlur={formik.handleBlur}
                                value={formik.values.country}
                              >
                                <option
                                  className="selectoptions"
                                  value=""
                                  selected
                                  hidden
                                >
                                  Select
                                </option>
                                {CountryList &&
                                  CountryList.map((country) => (
                                    <option
                                      key={country?.country_id}
                                      className="selectoptions"
                                      value={country.country_id}
                                    >
                                      {country.country_name}
                                    </option>
                                  ))}
                              </select>
                              {formik.touched.country &&
                                formik.errors.country && (
                                  <div className="error">
                                    {formik.errors.country}
                                  </div>
                                )}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="tp-checkout-input">
                              <label>State</label>
                              <select
                                id="state"
                                name="state"
                                className="checkoutSelect nice-select selectsection form-select"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.state}
                              >
                                <option
                                  className="selectoptions"
                                  value=""
                                  selected
                                  hidden
                                >
                                  Select
                                </option>
                                {StateList.length < 1 && (
                                  <option className="selectoptions" disabled>
                                    No Data Found
                                  </option>
                                )}
                                {StateList.length > 0 &&
                                  StateList.map((state) => (
                                    <option
                                      className="selectoptions"
                                      value={state.state_id}
                                    >
                                      {state.state_name}
                                    </option>
                                  ))}
                              </select>
                              {formik.touched.state && formik.errors.state && (
                                <div className="error">
                                  {formik.errors.state}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="tp-checkout-input">
                              <label>Town/City</label>
                              <input
                                type="text"
                                placeholder="City"
                                name="city"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.city}
                              />
                              {formik.touched.city && formik.errors.city && (
                                <div className="error">
                                  {formik.errors.city}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-md-8">
                            <div className="tp-checkout-input">
                              <label>Address</label>
                              <input
                                type="text"
                                placeholder="Address..."
                                name="address"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.address}
                              />
                              {formik.touched.address &&
                                formik.errors.address && (
                                  <div className="error">
                                    {formik.errors.address}
                                  </div>
                                )}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="tp-checkout-input">
                              <label>ZIP</label>
                              <input
                                type="text"
                                placeholder="Zip Code"
                                name="zip"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.zip}
                              />
                              {formik.touched.zip && formik.errors.zip && (
                                <div className="error">{formik.errors.zip}</div>
                              )}
                            </div>
                          </div>

                          {formik.values.shipToDifferentAddress === true && (
                            <>
                              <div className="col-md-12">
                                <div className="tp-checkout-option-wrapper">
                                  <h5 className="fw-semibold">
                                    Shipping Address
                                  </h5>
                                </div>
                              </div>

                              <div className="col-md-4">
                                <div className="tp-checkout-input">
                                  <label>Country</label>
                                  <select
                                    name="shipping_country"
                                    className="checkoutSelect nice-select selectsection form-select"
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      GetShippingStateList(e.target.value);
                                      formik.setFieldValue(
                                        "shipping_state",
                                        ""
                                      );
                                    }}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.shipping_country}
                                  >
                                    <option
                                      className="selectoptions"
                                      value=""
                                      selected
                                      hidden
                                    >
                                      Select
                                    </option>
                                    {CountryList &&
                                      CountryList.map((country) => (
                                        <option
                                          className="selectoptions"
                                          value={country.country_id}
                                        >
                                          {country.country_name}
                                        </option>
                                      ))}
                                  </select>
                                  {formik.touched.shipping_country &&
                                    formik.errors.shipping_country && (
                                      <div className="error">
                                        {formik.errors.shipping_country}
                                      </div>
                                    )}
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="tp-checkout-input">
                                  <label>State</label>
                                  <select
                                    name="shipping_state"
                                    className="checkoutSelect nice-select selectsection form-select"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.shipping_state}
                                  >
                                    <option
                                      className="selectoptions"
                                      value=""
                                      selected
                                      hidden
                                    >
                                      Select
                                    </option>
                                    {ShippingStateList.length < 1 && (
                                      <option
                                        className="selectoptions"
                                        disabled
                                      >
                                        No Data Found
                                      </option>
                                    )}
                                    {ShippingStateList.length > 0 &&
                                      ShippingStateList.map((state) => (
                                        <option
                                          className="selectoptions"
                                          value={state.state_id}
                                        >
                                          {state.state_name}
                                        </option>
                                      ))}
                                  </select>
                                  {formik.touched.shipping_state &&
                                    formik.errors.shipping_state && (
                                      <div className="error">
                                        {formik.errors.shipping_state}
                                      </div>
                                    )}
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="tp-checkout-input">
                                  <label>Town/City</label>
                                  <input
                                    type="text"
                                    placeholder="City"
                                    name="shipping_city"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.shipping_city}
                                  />
                                  {formik.touched.shipping_city &&
                                    formik.errors.shipping_city && (
                                      <div className="error">
                                        {formik.errors.shipping_city}
                                      </div>
                                    )}
                                </div>
                              </div>
                              <div className="col-md-8">
                                <div className="tp-checkout-input">
                                  <label>Address</label>
                                  <input
                                    type="text"
                                    placeholder="Address..."
                                    name="shipping_address"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.shipping_address}
                                  />
                                  {formik.touched.shipping_address &&
                                    formik.errors.shipping_address && (
                                      <div className="error">
                                        {formik.errors.shipping_address}
                                      </div>
                                    )}
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="tp-checkout-input">
                                  <label>ZIP</label>
                                  <input
                                    type="text"
                                    placeholder="Zip Code"
                                    name="shipping_zip"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.shipping_zip}
                                  />
                                  {formik.touched.shipping_zip &&
                                    formik.errors.shipping_zip && (
                                      <div className="error">
                                        {formik.errors.shipping_zip}
                                      </div>
                                    )}
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </form>
                  </div>
                  <hr className="mt-1" />

                  <div>
                    <h3 className="tp-checkout-bill-title mb-3">
                      Suggested Items
                    </h3>

                    <div>
                      <div className="row first-li">
                        {SuggestesList &&
                          SuggestesList.map((data) => (
                            <>
                              <div className="cart-top  bg-white right d-flex mb-10">
                                <div className="tp-checkout-option pt-10 pr-20">
                                  <input
                                    id="sugg_items"
                                    type="checkbox"
                                    onChange={(e) => {
                                      suggestedChanges(e, data);
                                    }}
                                    checked={suggestedItem}
                                  />
                                  <label htmlFor="sugg_items"></label>
                                </div>

                                <div
                                  className=""
                                  style={{ height: "90px", width: "100px" }}
                                >
                                  <img
                                    src={
                                      data?.MergedImage ||
                                      "assets/img/blog/bop-5.png"
                                    }
                                    alt="..."
                                    style={{
                                      objectFit: "contain",
                                      objectPosition: "top",
                                      height: "100%",
                                      width: "100%",
                                    }}
                                    onError={(e) =>
                                      (e.target.src =
                                        "assets/img/blog/bop-5.png")
                                    }
                                  />
                                </div>

                                <div className="content ps-3">
                                  <h5 className="fw-bold">{data?.Layout}</h5>
                                  <p className="text-left mb-2">
                                    {data?.size_detail?.size}
                                  </p>
                                  <h6>${data?.price}</h6>
                                </div>
                              </div>
                            </>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4" style={{ border: "1px solid #e7e7e7" }}>
                <div className="cart-top  bg-white right">
                  <div className="padding-dive d-flex pb-1">
                    <div className="modal-header border-0 w-100">
                      <h4 className="fw-normal">Order Summary</h4>
                      {/* <div class="cart-heading mb-10">Order Summary</div> */}
                      <h4 className="text-left pr-10">
                        {/* {localStorage.getItem("count")} Item(s) */}
                        {CartList.length} Item{CartList.length > 1 ? "s" : ""}
                      </h4>
                    </div>
                  </div>
                  <hr className="mt-0" />
                  <div
                    className="row first-li"
                    style={{ maxHeight: "439px", overflow: "auto" }}
                  >
                    {CartList &&
                      CartList.map((data) => (
                        <>
                          <div className="cart-top d-flex mb-10">
                            <div
                              className=""
                              style={{ height: "90px", width: "100px" }}
                            >
                              <img
                                src={
                                  data?.gift_card_Details
                                    ? data?.gift_card_Details?.image
                                    : data?.MergedImage
                                }
                                alt="..."
                                style={{
                                  objectFit: "contain",
                                  height: "100%",
                                  width: "100%",
                                }}
                              />
                            </div>
                            {data?.gift_card_Details ? (
                              <div className="content ps-2">
                                <h5 className="fw-bold">
                                  {data?.gift_card_Details?.name}
                                </h5>
                                <p className="text-left mb-2">
                                  Qty: {data?.quantity}
                                </p>
                                <h6>${data?.price}</h6>
                              </div>
                            ) : (
                              <div className="content ps-2">
                                <h5 className="fw-bold">
                                  {data?.Layout === "gallery_wall"
                                    ? "Gallery Wall"
                                    : data?.Layout === "story_canvas"
                                    ? "Story Canvas"
                                    : data?.Layout === "split_canvas"
                                    ? "Split Canvas"
                                    : data?.Layout === "single_panel"
                                    ? "Single Canvas"
                                    : data?.Layout === "plexi_print"
                                    ? "Plexi Print"
                                    : data?.Layout === "art_tray"
                                    ? "Art Tray"
                                    : data?.Layout === "wood_print"
                                    ? "Wood Print"
                                    : data?.Layout === "diamond_dust"
                                    ? "Diamond Dust"
                                    : "-"}
                                </h5>

                                {data?.Layout === "split_canvas" && (
                                  <p
                                    className="mb-2"
                                    style={{ fontSize: "smaller" }}
                                  >
                                    {data?.size_detail?.panels === 2
                                      ? "DYPTYCHS"
                                      : "TRYPTYCHS"}{" "}
                                    -{" "}
                                    {data?.size_detail?.price
                                      ? "Standard 3/4"
                                      : "Thick 1 1/2"}
                                  </p>
                                )}

                                {data?.Layout === "single_panel" && (
                                  <p
                                    className="mb-2"
                                    style={{ fontSize: "smaller" }}
                                  >
                                    {data?.type === "framed"
                                      ? "Framed"
                                      : data?.type === "thinGallery"
                                      ? "Thin Gallery Wrap (0.75)"
                                      : data?.type === "thickGallery"
                                      ? "Thick Gallery Wrap (1.5)"
                                      : data?.type === "rolled"
                                      ? "Rolled in a Tube"
                                      : ""}
                                  </p>
                                )}

                                <p className="text-left mb-2">
                                  {data?.size_detail?.size}
                                </p>
                                <p className="text-left mb-2">
                                  Qty: {data?.quantity}
                                </p>
                                <p className="text-left mb-2">
                                  Edge/Services (${data?.additionalprice || 0})
                                </p>

                                <h6>${data?.price}</h6>
                              </div>
                            )}
                          </div>{" "}
                          <hr className="my-2" />
                        </>
                      ))}
                  </div>
                  <div className="row pt-2">
                    <hr />
                    <div className="tp-checkout-input cart ">
                      <label>Promo Code </label>
                      <div className="d-flex position-relative">
                        <input
                          type="text"
                          placeholder="Enter Your Code"
                          name="promoCode"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.promoCode}
                          className={`${
                            PromoApplySubmit &&
                            !formik.values.promoCode &&
                            "border_error"
                          } pe-5`}
                        />
                        {PromoApplySubmit && formik.values.promoCode && (
                          <span
                            style={{
                              position: "absolute",
                              top: "13px",
                              right: "85px",
                            }}
                            className="pointer"
                            onClick={removePromoCode}
                          >
                            <i className="fa-regular fa-circle-xmark"></i>
                          </span>
                        )}
                        {PromoApplySubmit && !formik.values.promoCode && (
                          <span
                            style={{
                              position: "absolute",
                              top: "13px",
                              right: "85px",
                            }}
                          >
                            <i className="fa-circle-exclamation fa-regular fa-xl text-danger"></i>
                          </span>
                        )}
                        <button
                          className="btn btn-light rounded-0"
                          onClick={ApplyPromoCode}
                        >
                          {PromoCodeDetails?.type ? "Apply" : "Apply"}
                        </button>
                      </div>
                      {PromoCodeDetails?.type && (
                        <small className="text-primary fw-semibold">
                          Applied!
                        </small>
                      )}
                    </div>
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                      <div className="content d-flex justify-content-between popup">
                        <h5>Subtotal</h5>
                        <p className="pr-20">${CardSummary?.subtotal || 0.0}</p>
                      </div>
                      <div className="content d-flex justify-content-between popup">
                        <h5>Shipping </h5>
                        <p className="pr-20">
                          ${CardSummary?.shippingprice?.toFixed(2) || 0.0}
                        </p>
                      </div>
                      {CardSummary?.discount > 0 && (
                        <div className="content d-flex justify-content-between popup">
                          <h5>
                            Discount{" "}
                            <span>
                              {PromoCodeDetails?.type === "fixed"
                                ? "(flat)"
                                : PromoCodeDetails?.type === "percent"
                                ? `(${PromoCodeDetails?.discount}%)`
                                : ""}
                            </span>
                          </h5>
                          <p className="pr-20">
                            - ${CardSummary?.discount || 0}
                          </p>
                        </div>
                      )}
                      {suggestedItem && (
                        <div className="content d-flex justify-content-between popup">
                          <h5>Suggested Item</h5>
                          <p className="pr-20">
                            ${CardSummary?.suggested_item_price}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                      <div className="content d-flex justify-content-between popup two three">
                        <h5>Total</h5>
                        <h5 className="pr-20">${CardSummary?.total || 0.0}</h5>
                      </div>
                    </div>
                  </div>

                  <div className="tp-header__chat-box m-0 pt-30">
                    <button
                      className={`tp-btn-lg large head price one btn m-0 w-100 ${
                        formik.isValid ? "" : "disabled"
                      }`}
                      style={{ background: "#1F4CE0", border: "#1F4CE0" }}
                      onClick={formik.handleSubmit}
                      type="submit"
                    >
                      {btnLoader ? (
                        <span>
                          <i className="fa fa-spinner fa-spin fa-fw"></i>
                        </span>
                      ) : (
                        "Proceed To Pay"
                      )}
                    </button>
                    <button
                      data-bs-toggle="modal"
                      className="d-none"
                      id="paymentModal"
                      data-bs-target="#yourCart"
                    ></button>
                  </div>

                  <div className="d-none">
                    <a
                      href="#"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      id="openloginModalforGuest"
                    ></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {Loading ? (
        <div className="LoaderSpinner">
          <BounceLoader
            color={"#607fe6"}
            loading={Loading}
            speedMultiplier={2}
            size={50}
          />
          <div className="fw-semibold">Loading... Please wait.</div>
        </div>
      ) : (
        ""
      )}

      {/* modal three */}
      <div
        className="modal fade index"
        id="yourCart"
        tabIndex={-1}
        aria-labelledby="exampleModalLabelone"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header border-0">
              <h4 className="text-left">Select Payment Method</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="close"
              />
            </div>
            <div className="modal-body popup border-0 pt-0">
              <div className="box">
                <div className="content d-flex justify-content-between align-items-center m-0 popup">
                  <h5 className="mb-0">Total Amount to Pay -</h5>
                  <p className="text-right m-0">${CardSummary?.total}</p>
                </div>
              </div>
              <hr />

              {paypal && (
                <div className="d-flex row justify-content-center">
                  <div className="">
                    <div className="content mt-0 two three text-center popup">
                      <div className="tp-checkout-payment-item paypal-payment">
                        {/* <input type="radio" id="paypal" name="payment" />
                      <label htmlFor="paypal">PayPal</label>
                      <img
                        className="mt-20"
                        src="assets/img/breadcrumb/AM_mc_vs_dc_ae 1.png"
                        alt=""
                      /> */}
                        {/* <PayPalButtonComponent
                          clientId={clientId}
                          amount={CardSummary?.total}
                          onSuccess={onSuccess}
                          onError={onError}
                        /> */}

                        <BraintreeCheckout onSuccess={onSuccess} />
                      </div>
                    </div>
                  </div>

                  {/* <div className="col-xl-8 col-lg-8 col-md-8">
                  <div className="content d-flex justify-content-between popup two three">
                    <div className="tp-checkout-payment-item paypal-payment">
                      <input type="radio" id="Cards" name="payment" />
                      <label htmlFor="Cards">
                        BRAINTREE - Pay with your Credit Cards
                      </label>
                      <img
                        className="mt-20"
                        src="assets/img/breadcrumb/Group 3263.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div> */}

                  {/* <div className="row">
                  <div className="col-12">
                  <PayPalButtonComponent
        clientId={clientId}
        amount={CardSummary?.total}
        onSuccess={onSuccess}
        onError={onError}
      />
                  </div> 
                </div> */}
                </div>
              )}

              <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                  {/* <div className="content d-flex justify-content-between popup two">
                    <h5>Quantity</h5>
                    <h5 className="text-right">1</h5>
                  </div> */}
                  <div className="tp-header__chat-box  pt-30 pb-4">
                    {/* <span
                      className="tp-btn-lg large head price one"
                      onClick={ProceedToSelectMethod}
                      // onClick={ProceedToPay}
                      style={{
                        background: "#1F4CE0",
                        border: "#1F4CE0",
                        cursor: "pointer",
                      }}
                    >
                      Proceed to Pay
                    </span> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* modal three */}
    </div>
  );
}
